import React from 'react';
import get_bundle from '../../../domain/get_bundle';
import Locale from '../../../domain/Locale';
import URL from '../../../domain/URL';
import SponsorDomain from '../../../domain/Sponsor';
import Color from '../../../domain/Color';
import Widget from '../../../domain/Widget';
import ReducerDomain from '../../../domain/Reducer';
import WidgetLayout from '../../../components/WidgetLayout';
import WidgetHeader from '../../../components/WidgetHeader';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  sponsor: t.maybe(SponsorDomain),
  reducer: ReducerDomain,
  context: t.Obj,
  like_url: t.Str,
  gplus_url: t.Str,
  do_reduce: t.Func,
  do_skip: t.Func,
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  widget: t.maybe(Widget),
  miniSiteURL: URL
})
export default class Reducer extends React.Component {

  constructor(...args){
    super(...args);

    const do_reduce = (value) => {
       this.props.do_reduce(value);
    };
    const do_skip = () => {
       this.props.do_skip();
    };

    const getStyleBtnColor = () => {
      return 'style="background-color:' + this.props.themeBtnColor + '; color:' + this.props.themeBtnFontColor + '"'; //, color:"' + this.props.themeBtnFontColor + '"'
    };

    const reducer_sandbox = {
      locale: this.props.locale,
      like_url: this.props.like_url,
      gplus_url: this.props.gplus_url,
      context: this.props.context,
      default_privacy: this.props.sponsor ? this.props.sponsor.privacy : null,
      do_reduce: do_reduce,
      do_skip: do_skip,
      styleBtnColor: getStyleBtnColor()
    };

    this.state = {
      reducer: this.props.reducer.to_widget(reducer_sandbox)
    };
  }

  getHeader() {
    return (<WidgetHeader widget={this.props.widget}/>);
  }

  getContent() {
    return <div dangerouslySetInnerHTML={{__html: this.state.reducer.to_html()}}></div>;
  }

  componentDidMount() {
    this.state.reducer.start();
  }

  componentWillUnmount() {
    this.state.reducer.stop();
  }

  getReducerLayout() {
    const {locale, themeBgColor, themeBgFontColor} = this.props;
    const bundle = get_bundle(locale).reducer;

    const styleBgColor = {
      backgroundColor: themeBgColor,
      color: themeBgFontColor
    };

    return (
      <div className='cell'>
        <div id='reducer_container'>
          <div id='reducer_title' className='box dark' style={styleBgColor}>
            <h1 className='large-text-center' >{bundle.title}</h1>
          </div>
          { this.getContent() }
        </div>
      </div>
    );
  }

  getWidgetFooterImage() {
    if (!this.props.widget) {
      return null;
    }
    return this.props.widget.footer_image;
  }

  render() {
    console.log("render")
    const {locale} = this.props;

    return (
      <WidgetLayout header={this.getHeader()} locale={locale} miniSiteURL={this.props.miniSiteURL} footerImage={this.getWidgetFooterImage()}>
        <div id='reducer'>
          <div className='cols'>
            {this.getReducerLayout()}
          </div>
        </div>
      </WidgetLayout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/widget/Reducer.js
 **/